import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const TRACKING_WIRING: Wiring = {
  [EVENTS.ResultClicked]: [
    WIRES.trackPendingQuery,
    WIRES.trackClick,
    WIRES.saveResultToLocalStorage,
    WIRES.addResultIDToClickedHistory,
    WIRES.saveStoreStateToCache
  ],
  [EVENTS.PromotedRightClicked]: [
    WIRES.saveItemToLocalStorageWithURL
  ],
  [EVENTS.PromotedClicked]: [
    WIRES.trackPendingQuery,
    WIRES.trackClick
  ],
  [EVENTS.BannerClicked]: [
    WIRES.trackPendingQuery,
    WIRES.trackClick
  ],
  [EVENTS.BannerRightClicked]: [
    WIRES.saveItemToLocalStorageWithURL
  ],
  [EVENTS.ResultClickedWithQueryTracking]: [
    WIRES.trackQueryAndEmitResultClicked
  ],
  [EVENTS.ResultRightClicked]: [
    WIRES.saveResultToLocalStorage,
    WIRES.saveRightClickedResultIdToLocalStorage,
    WIRES.addResultIDToClickedHistory
  ],
  [EVENTS.ProductPageDetected]: [
    WIRES.loadResultId,
    WIRES.moveResultToSessionStorage
  ],
  [EVENTS.Add2CartOnProductPageClicked]: [
    WIRES.trackAdd2cartOnProductPage,
    WIRES.addResultToLocalStorageCheckout
  ],
  [EVENTS.Add2CartOnResultClicked]: [
    WIRES.trackClick,
    WIRES.trackAdd2cartOnResult,
    WIRES.addResultToLocalStorageCheckout
  ],
  [EVENTS.ResultsEnd]: [
    WIRES.enableResultsEnd,
    WIRES.trackResultsEnd
  ],
  [EVENTS.Checkout]: [
    WIRES.trackCheckout,
    WIRES.removeLocalStorageCheckout
  ],
  [EVENTS.AddToWishlistSuccess]: [
    WIRES.addToWishlist,
    WIRES.updateResult,
    WIRES.trackToggleWishlist
  ],
  [EVENTS.RemoveFromWishlistSuccess]: [
    WIRES.removeFromWishlist,
    WIRES.updateResult,
    WIRES.trackToggleWishlist
  ]
};
